const fileUpload = {
  'file-upload.upload': 'Upload file',
  'file-upload.uploading': 'Uploading...',
  'file-upload.success': 'File uploaded successfully',
  'file-upload.error': 'File uploaded failed',
  'file-upload.error.message': 'File uploaded failed',
  'file-upload.formatHint': 'Supported formats: {accept}',
  'file-upload.sizeHint.max': 'File size must be less than {maxSize}Mb',
  'file-upload.countLimit': 'Maximum number of files: {maxCount}',
  'file-upload.singleFile': 'Can only upload one file',
};

export default fileUpload;
